import React, { useState } from 'react'
import './style.css'
import award1 from '../../images/awards/award1.jpeg'
import award2 from '../../images/awards/award2.jpg'

const Awards = (props) => {
    const { 
        highlightImage, 
        awards = [
            "Excellence in Art & Culture Award on 124th Foundation Day of Cotton University 2024, Cotton University",
            "Honoured for Best Mime Act at SIAM’s Safe Annual Convention 2023, SIAM India",
            "Junior Fellowship, CCRT, Ministry of Culture, Government of India",
            "Senior Scholarship for Mime, Ministry of Culture, Government of India (2018)",
            "Young Talented Artist Award, NEZCC, Ministry of Culture, Government of India",
            "'Champion of Mime' Award, Youth Conclave(2017), B. Barooah College"
        ]
    } = props;

    const [modalImage, setModalImage] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = (imageSrc, altText) => {
        setModalImage({ src: imageSrc, alt: altText });
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setModalImage(null);
    };

    return (
        <div className="awards-section">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="awards-content">
                            {/* Section Title */}
                            <div className="awards-title">
                                <h2>Awards & Recognition</h2>
                                <p>Honored for our dedication to making a positive impact in the community</p>
                            </div>

                            {/* Highlight Image */}
                            {highlightImage && (
                                <div className="awards-highlight-image">
                                    <img src={highlightImage} alt="Awards Highlight" />
                                </div>
                            )}

                            {/* Awards List */}
                            <div className="awards-list">
                                <h3>Our Achievements</h3>
                                <div className="awards-grid">
                                    {awards.map((award, index) => (
                                        <div key={index} className="award-item">
                                            <div className="award-icon">
                                                <i className="fa fa-trophy"></i>
                                            </div>
                                            <p>{award}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* Awards Gallery */}
                            <div className="awards-gallery">
                                <h3>Certificate</h3>
                                <div className="awards-images">
                                    <div className="award-image" onClick={() => openModal(award1, "Certificate 1")}>
                                        <img src={award1} alt="Certificate 1" />
                                        <div className="image-overlay">
                                            <i className="fa fa-search-plus"></i>
                                            <span>Click to view</span>
                                        </div>
                                    </div>
                                    <div className="award-image" onClick={() => openModal(award2, "Certificate 2")}>
                                        <img src={award2} alt="Certificate 2" />
                                        <div className="image-overlay">
                                            <i className="fa fa-search-plus"></i>
                                            <span>Click to view</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Modal */}
                            {isModalOpen && (
                                <div className="certificate-modal" onClick={closeModal}>
                                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                                        <button className="modal-close" onClick={closeModal}>
                                            <i className="fa fa-times"></i>
                                        </button>
                                        <img src={modalImage?.src} alt={modalImage?.alt} />
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Awards;
